import ProxyBase from '../../../../../../../core/proxies/ProxyBase'

export class ImportExportProxy extends ProxyBase {
  getImportExportData(params) {
    return this.get('ImportAndExport', params)
  }
}

export default new ImportExportProxy('IndustryOverview/')
